module.exports = __webpack_public_path__ + "media/components/country-flag/static/sd-4661bdec67a07402fcee02541afdf0d1.svg";